export default __webpack_public_path__ + "static/media/at-sign.a536ba62.svg";